module.exports = __webpack_public_path__ + "img/1.1def8e59.png";